/** Locale-aware labels for deletion cases (values stay API-stable). */

const VIOLATION_VALUES = [
  { value: "Spam", key: "cases.violation.spam" },
  { value: "Interessenkonflikt", key: "cases.violation.conflict" },
  { value: "Beleidigung", key: "cases.violation.insult" },
  { value: "Falsche Tatsachen", key: "cases.violation.falseFacts" },
  { value: "Datenschutz", key: "cases.violation.privacy" },
  { value: "Sonstiges", key: "cases.violation.other" },
];

const STATUS_KEYS = {
  initiated: "cases.status.initiated",
  started: "cases.status.started",
  legal_action: "cases.status.legal_action",
  completed: "cases.status.completed",
  rejected: "cases.status.rejected",
};

export function getCaseStatusLabel(t, status) {
  const key = STATUS_KEYS[status];
  return key ? t(key) : status;
}

export function getCaseStatusLabels(t) {
  return Object.fromEntries(
    Object.entries(STATUS_KEYS).map(([value, key]) => [value, t(key)])
  );
}

export function getViolationTypeOptions(t) {
  return VIOLATION_VALUES.map(({ value, key }) => ({
    value,
    label: t(key),
  }));
}

export function getCaseStatusFilterOptions(t) {
  return [
    { value: "", label: t("cases.allStatus") },
    ...Object.entries(STATUS_KEYS).map(([value, key]) => ({
      value,
      label: t(key),
    })),
  ];
}

export function getViolationTypeFilterOptions(t) {
  return [
    { value: "", label: t("cases.allViolations") },
    ...getViolationTypeOptions(t),
  ];
}

/** @deprecated Use getViolationTypeOptions(t) */
export const VIOLATION_TYPE_OPTIONS = VIOLATION_VALUES.map((v) => ({
  value: v.value,
  label: v.value,
}));
